<template>
  <div>
    <nuxt-link v-if="link" :external="true" :to="link" class="n-link tw-block tw-mb-6">
      <library-image
        v-if="photo"
        :src="photo"
        :alt="title"
        :w-ratio="7"
        :h-ratio="4"
      />
    </nuxt-link>

    <h3
      v-if="title"
      class="tw-line-clamp-1 tw-h-10 tw-mb-4"
      :style="{ color: textColor }"
    >
      {{ title }}
    </h3>

    <nuxt-link v-if="link" :external="true" :to="link" :class="`n-${buttonType} tw-w-fit`">
      {{ buttonLabel }}
      <span v-if="buttonType?.toString().includes('secondary icon')" class="btn-arrow">
        <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z"
            :fill="`var(--c-${textColor})`"
          />
        </svg>
      </span>
    </nuxt-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';

export default defineComponent({
  name: 'CaseStudyCard',
  props: {
    photo: {
      type: String as PropType<string>,
      default: '',
    },
    title: {
      type: String as PropType<string>,
      default: '',
    },
    link: {
      type: String as PropType<string>,
      default: '',
    },
    buttonLabel: {
      type: String as PropType<string>,
      default: 'READY CASE STUDY',
    },
    buttonType: {
      type: String as PropType<string>,
      default: 'link',
    },
    textColor: {
      type: String as PropType<string>,
      default: '#000000',
    },
  },
});
</script>
